import { render, staticRenderFns } from "./CampaignConfirmItem.vue?vue&type=template&id=a4421b16&scoped=true&"
import script from "./CampaignConfirmItem.vue?vue&type=script&lang=js&"
export * from "./CampaignConfirmItem.vue?vue&type=script&lang=js&"
import style0 from "./CampaignConfirmItem.vue?vue&type=style&index=0&id=a4421b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4421b16",
  null
  
)

export default component.exports